<template>
    <Loading v-bind:show="showLoading">
        <PageTitle title="Carnês - Deletados" />
        <div v-if="dadosAba">
            <div style="clear:both"></div>
            <GridCarne v-bind:Data="dadosAba"
                       v-bind:Header="header"
                       Name="Deletados"
                       Title="Total"
                       OrderBy="periodo"
                       v-bind:HeaderDetalhes="null"
                       v-bind:DetalhesCombo1="dadosAba.periodo"
                       v-bind:DetalhesCombo2="null"
                       v-bind:DetalhesCombo3="null" />
        </div>
    </Loading>
</template>

<script>
    import Loading from '@/components/Loading';
    import CarneService from '@/services/CarneService.js';
    import GridCarne from '@/components/GridCarnes';
    import PageTitle from '@/components/PageTitle';

    export default {
        name: 'CarneDeletado',
        components: {
            GridCarne,
            Loading,
            PageTitle
        },
        data() {
            return {
                dadosAba: null,
                rangePeriodo: null,
                showLoading: false,

                headerAtivo: [
                    {
                        Titulo: "Tipo",
                        Field: "tipo",
                        Width: "100px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Descrição",
                        Field: "descricao",
                        Width: "100px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Número do documento",
                        Field: "numeroDocumento",
                        Width: "120px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Valor",
                        Field: "valor",
                        Width: "80px",
                        Tipo: "moeda"
                    },
                    {
                        Titulo: "Data pagamento",
                        Field: "dataPagamento",
                        Width: "80px",
                        Tipo: "date"
                    },
                    {
                        Titulo: "Transação",
                        Field: "transacao",
                        Width: "80px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Situação",
                        Field: "situcod",
                        Width: "100px",
                        Tipo: "texto"
                    }
                ]
            }
        },

        created() {
            //Verifica se tem aluno selecionado
            if (!sessionStorage.Aluno)
                this.$router.push('home')


            let a = JSON.parse(sessionStorage.Aluno);
            this.aluno = a.PerfilAluno;

            //Verifica se a aba ja está carregada
            if (this.aluno.CarneDeletado) {
                this.dadosAba = a.Carne;
            }
            else {
                if (this.$featureToggle.INTEGRA_CARNE_DELETADO) {
                    this.dadosAba = [];

                    this.carneService = new CarneService(this);

                    //Popula os dados da aba
                    this.showLoading = true;
                    this.carneService.ExtratoFinanceiroCompleto({
                        CodigoAluno: this.aluno.codigoAluno,
                        CodigoEspecialidade: this.aluno.codigoEspecialidade,
                        CodigoEmpresa: this.aluno.codigoEmpresa,
                    }).then(
                        data => {
                            if (data.ok) {
                                this.dadosAba = data.dados;
                            }
                            else {
                                this.$modal.info(data.Mensagem);
                            }
                        },
                        error => {
                            if (error.status != 500)
                                this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                            else
                                this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                        }).finally(() => {
                            this.showLoading = false;
                        });
                }
            }
        },
        beforeDestroy() {
            let aluno = JSON.parse(sessionStorage.Aluno);

            //Armazena os dados da aba pra nao precisar carregar novamente
            aluno.CarneDeletado = this.dadosAba;
            sessionStorage.setItem("Aluno", JSON.stringify(aluno));
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .md-field {
        max-width: 100%;
        font-weight: bold;
    }

    .full-control {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap-reverse;
    }

    .list {
        width: 320px;
    }

    .titulo {
        margin: 0;
        padding: 0 0 0 15px;
        font-weight: bold;
    }



    .divResumo {
        width: 100%;
        float: left;
        position: relative;
        display: inline;
        margin-top: 20px;
    }





    .md-tab {
        padding: 0;
        margin: 0 !important;
    }
</style>
